<template>
    <HeaderView />
    <router-view />
    <FooterView v-if="globalState.showFooter" />
</template>

<script>
import HeaderView from './views/HeaderView.vue';
import FooterView from './views/FooterView.vue';
import { globalState } from './router/router.js'; // Import global state from router.js

export default {
  name: 'App',
  components: {
    HeaderView,
    FooterView
  },
  setup() {
    return { globalState };
  }
};
</script>

<style>
/* === MODERN SCROLLBAR STYLE === */
::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

/* Track (the background area) */
::-webkit-scrollbar-track {
  background: var(--scroll-track);
}

/* Scroll thumb (the draggable part) */
::-webkit-scrollbar-thumb {
  background-color: var(--scroll-thumb);
  transition: background-color 0.3s ease, border 0.3s ease;
}

/* Hover effect */
::-webkit-scrollbar-thumb:hover {
  background-color: var(--scroll-thumb-hover);
}

/* Corner (when both scrollbars meet) */
::-webkit-scrollbar-corner {
  background: transparent;
}

body {
  margin-bottom: 0;
}


</style>
